module.exports = __webpack_public_path__ + "img/infraestructura.346662cb.png";